import { lenis } from '../app'

const anchor = () => {
    const anchorTargets = document.querySelectorAll('[data-anchor-target]')

    anchorTargets.forEach((target) => {
        const { anchorTarget } = target.dataset
        const anchorTargetElement = document.getElementById(anchorTarget)
        if (!anchorTargetElement) return
        target.addEventListener('click', (e) => {
            e.preventDefault()
            lenis.scrollTo(anchorTargetElement.offsetTop)
        })
    })

    scrollToHash()
}

// When the page loads with a hash (e.g. arriving from the collection page via
// /#the-location), Lenis owns the scroll so the browser's native hash jump never
// happens. Scroll to the target manually once layout has settled.
const scrollToHash = () => {
    const { hash } = window.location
    if (!hash) return

    const target = document.getElementById(hash.slice(1))
    if (!target) return

    const doScroll = () => lenis.scrollTo(target.offsetTop, { immediate: true })

    if (document.readyState === 'complete') {
        doScroll()
    } else {
        // Wait for splash/images/fonts so the offset is accurate.
        window.addEventListener('load', doScroll, { once: true })
    }
}

export default anchor
